import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg text-center">
        <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
          MathBoss
        </h1>
        <p className="text-gray-600 mb-8">
          Learn math in a fun and interactive way!
        </p>
        <div className="space-y-4">
          <button 
            onClick={() => navigate('/login')}
            className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home; 